import { render, staticRenderFns } from "./AddFIMonthlyReport.vue?vue&type=template&id=78798f24&"
import script from "./AddFIMonthlyReport.vue?vue&type=script&lang=js&"
export * from "./AddFIMonthlyReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports